export enum DealStatusEnum {
  Open = 1,
  Won = 2,
  Lost = 3,
  Archive = 4,
}
